function newsOverview() {
  const dropdown = document.getElementById('blog_search');
  const form = document.querySelector('.news--overview-form');
  console.log(dropdown, form);
  dropdown.addEventListener('change', function (event) {
    let value = event.currentTarget.value;
    if (value) {
      form.submit();
    }
  });
}
